/**
 * Centralized configuration for the application
 */

const getApiUrl = () => {
    // Can be overridden by REACT_APP_API_URL environment variable
    // if (process.env.REACT_APP_API_URL) {
    //     return process.env.REACT_APP_API_URL;
    // }

    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    // Production: API is served through nginx reverse proxy on same domain
    if (hostname.endsWith('ypecode.com.br')) {
        return `${protocol}//${hostname}`;
    }

    // Default port for backend in development
    const port = "8000";

    // If we are on localhost, we check if it's a subdomain or main domain
    return `${protocol}//${hostname}:${port}`;
};

export const API_BASE_URL = getApiUrl();
export const MAIN_DOMAIN = window.location.hostname.endsWith('ypecode.com.br')
    ? 'agenda.ypecode.com.br'
    : 'localhost';

/**
 * Get WhatsApp webhook URL based on current environment
 */
export const getWebhookUrl = (): string => {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    // Production: Use the API base URL
    if (hostname.endsWith('ypecode.com.br')) {
        return `${protocol}//${hostname}/api/whatsapp/webhook/`;
    }

    // Development: Use port 8000
    return `${protocol}//${hostname}:8000/api/whatsapp/webhook/`;
};
